const prefix = 'audit_missions'

export const SET_AUDIT_MISSIONS = `${prefix}/SET_AUDIT_MISSIONS`
export const SET_SELECTED_AUDIT_MISSION = `${prefix}/SET_SELECTED_AUDIT_MISSION`
export const SET_PER_PAGE = `${prefix}/SET_PER_PAGE`
export const SET_SEARCH = `${prefix}/SET_SEARCH`
